import React, { memo } from 'react'
import { useCartItem, CartItemProps } from './useCartItem'
import styles from './CartItem.module.scss'

const CartItem: React.FC<CartItemProps> = (props: CartItemProps) => {
  const {
    name,
    price,
    currency,
    quantity,
    variantName,
    handleIncrease,
    handleDecrease,
  } = useCartItem(props)

  return (
    <div className={styles['cart-item']}>
      <div className={styles['item-info']}>
        <h3>
          {name}
          {variantName && (
            <span className={styles['variant-badge']}>{variantName}</span>
          )}
        </h3>
        <span className={styles['item-price']}>
          {price} {currency}
        </span>
      </div>
      <div className={styles['item-actions']}>
        <button onClick={handleDecrease}>
          <i className='bi bi-dash'></i>
        </button>
        <span className={styles['quantity']}>{quantity}</span>
        <button onClick={handleIncrease}>
          <i className='bi bi-plus'></i>
        </button>
      </div>
    </div>
  )
}

export default memo(CartItem)
